<script>
export default {
  name: "ManualAuto",
  data() {
    return {
      showContent: false,
    };
  },
  props: {
    value: {
      validator: (prop) => typeof prop === "boolean" || prop === null,
      required: true,
    },
  },
  mounted() {
    this.showContent = true;
  },
  methods: {
    color(expectedValue) {
      if (
        this.value === expectedValue &&
        document.getElementById("thermostat")
      ) {
        const classNames = document.getElementById("thermostat").classList;
        const backgroundClass = [...classNames].find((c) =>
          c.includes("Background")
        );

        if (backgroundClass)
          return backgroundClass.replace("Background", "Color");
      } else {
        // white background
        return;
      }

      return "pinkColor";
    },
  },
};
</script>

<template>
  <div class="container" v-if="showContent">
    <div class="control">
      <div
        :class="[{ isActive: value === false }, color(false)]"
        @click="$emit('input', false)"
      >
        <span>{{ $t("thermostat.manual") }}</span>
      </div>
      <div
        :class="[{ isActive: value === true }, color(true)]"
        @click="$emit('input', true)"
      >
        <span>{{ $t("thermostat.auto") }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.container {
  max-width: 125px;

  .control {
    display: flex;
    justify-content: center;
    font-size: 14px;
    border-radius: 20px;

    > div {
      border: 1px solid white;
      width: 100%;
      padding: 3px;
      text-align: center;
      cursor: pointer;
    }

    div:first-child {
      border-radius: 20px 0 0 20px;
    }

    div:last-child {
      border-radius: 0 20px 20px 0;
    }
  }
}

.isActive {
  background-color: white;
}

.pinkColor {
  color: #d584b5;
}
</style>
